//import moment from 'moment';
import moment from 'moment';
// tslint:disable-next-line
import { PathLocationStrategy, HashLocationStrategy } from '@angular/common';
//import { Component } from '@angular/core';
import {environment} from "../environments/environment";

export class AppSettings {
	public static DEBUG = false;
	public static ION_DATETIME_FORMAT = 'YYYY-MM-DD';
	// dev
	// public static FS_API_KEY = 'STXR8f?|#8|9';
	// public static FS_API_client = 'facharzt-sofort-apps';
	// public static FS_API_URL = 'http://138.201.33.176:9000/';
	// public static FS_MAIN_URL = 'http://138.201.33.176:8999/';
	// production
	public static FS_API_KEY = '{[-J!4/P}aW)';
	public static FS_API_client = 'facharzt-sofort-apps';
	public static FS_MAIN_URL = 'https://termed.de/';
	// public static FS_API_URL = 'https://api.termed.de/';

 	/*public static FS_DOC_URL = 'https://testdoc2023.termed.de/';
	public static FS_PAT_URL = 'https://test2023.termed.de/';*/ 
	public static FS_PAT_URL = 'https://www.termed.de/';


	public static FS_API_URL = 'https://testapi.termed.de/v2/';
	public static FS_API_BASEURL = 'https://testapi.termed.de/';
    /*public static FS_API_URL = 'https://testapi.termed.de/v2/';
	public static FS_API_BASEURL = 'https://testapi.termed.de/';*/   

	public static FCM_SENDER_ID = '909911555303';

	public static EXPIRATION_ID_POSTFIX = "_exp";
	public static EXPIRATION_INTERVAL_DEFAULT = 0;
	public static EXPIRATION_APP = 86400;
	public static EXPIRATION_INTERVAL_NEVER = 31536000 * 2; // 2 years
	public static EXPIRATION_INTERVAL_DOC = 86400; //1 tage
	public static EXPIRATION_INTERVAL_DOC_OPEN_APPS = 30;
	public static EXPIRATION_INTERVAL_PRAXIS = 172800; //2 tage
	public static EXPIRATION_INTERVAL_SEARCH = 60;
	public static EXPIRATION_INTERVAL_REFRESH_TOKEN = 31536000; //1 year in seconds
	public static EXPIRATION_INTERVAL_PATIENT = 86400; // 1 tag
	public static EXPIRATION_INTERVAL_PATIENT_HISTORY = 60;
	public static EXPIRATION_INTERVAL_PATIENT_FREQUENT_DOCS = 60;
	public static EXPIRATION_INTERVAL_PATIENT_OPEN_APPS = 30;
	public static EXPIRATION_INTERVAL_EVENT = 30;
	public static EXPIRATION_INTERVAL_MED = 172800; //2 tage
	public static EXPIRATION_INTERVAL_PATIENT_MESSAGES = 30;
	public static EXPIRATION_INTERVAL_SPECS = 7200; //2 hours
	public static LIMIT_PATIENT_FREQUENT_DOCS = 5;

	public static CUSTOM_VERSION = "default";

	public static DOC_CALENDAR_LIVE_RELOAD_TIME = 60;

	public static INSURANCE_DEFAULT = 10;
	public static SEARCH_RADIUS_DEFAULT = "30";
	public static SORT_OPTION_DEFAULT = "0";
	public static SEARCH_START_MIN = moment().format(AppSettings.ION_DATETIME_FORMAT);
	public static SEARCH_START_MAX = moment().add(1, 'years').format(AppSettings.ION_DATETIME_FORMAT);
	public static SEARCH_START_NOW = moment().format(AppSettings.ION_DATETIME_FORMAT);

	public static REGIS_MAX_AGE = moment().subtract(120, 'years').format(AppSettings.ION_DATETIME_FORMAT);
	public static REGIS_MIN_AGE = moment().subtract(0, 'years').format(AppSettings.ION_DATETIME_FORMAT);
	public static REGIS_START_AGE = moment().subtract(35, 'years').format(AppSettings.ION_DATETIME_FORMAT);

	public static MAP_ZOOM = 17;
	public static MAP_LAT = 49.020261;
	public static MAP_LNG = 12.097339;
	public static MAP_LNG_OFFSET = 0.0015;

	public static APP_HISTORY_OFFSET = 0;
	public static APP_HISTORY_INTERVAL = 5;

	public static CACHE_VERSION = 14;
	public static CACHE_CLEAR_INSTRUCTION = 1; // 0 cache soft clear, 1 cache hard clear

	public static ANALYTICS_TRACKING_ID = "UA-75756485-2";
	public static GOOGLE_API_KEY = 'AIzaSyABMwsJPKUArVFIh7Bqy9xyfm9vWAntTX8';

	public static STARTSEITE = 'termedinfos';
	public static HEADER_BG_URL = 'assets/images/doc_hero.jpg';
	public static HEADER_BG_SIZE = 'auto 100%';
	public static HEADER_BG_POSITION = '50% 0%';

   // public static LOGO_URL = 'assets/images/termed_logo_horizontal.png';
	public static LOGO_URL = 'assets/images/newDesign/Logo_00_Termed_Logo_Blau.png';
	public static LOGO_ALT = 'TerMed Logo';

	public static HIDE_DOC_ADRESS = false;

	public static MAP_MARKER = '';

	public static ADDITIONAL_LINKS = [];

	public static APPID = '1';

	public static APP_BASE_HREF = '/';
	//public static LocationStrategy = HashLocationStrategy;
	public static LocationStrategy = PathLocationStrategy;

	public static DEFAULT_ACTION_TEXT = 'Termin buchen';
	public static DEFAULT_STANDORT_TEXT = 'Wählen Sie einen unserer Standorte aus, um einen Termin bei einem unserer Ärzte buchen zu können';
	public static RECIPE_REQUEST_ADDITION = '';
	public static CUSTOM_STANDORT_ACTION = false;

	private static _usedLang = "de";
  	static DEFAULT_LAT: number;
	
	
	public static getLanguage() {
		return this._usedLang;
	}

	public static setLanguage(lang) {
		this._usedLang = lang;
	}

	public static PATPAGES_LIST = [
	//	{ title: 'pages.pat_search', component: 'suche', command: 0, icon: "search", showOnLogin: true, showAsGuest: true, hideAsDoc: false, separate: false, onlyInWeb: false, href: "/suche", expanded: false, children: [] },
		{ title: 'pages.pat_search', component: 'start', command: 0, icon: "search", showOnLogin: true, showAsGuest: true, hideAsDoc: false, separate: false, onlyInWeb: false, href: "/start", expanded: false, children: [] },
		{ title: 'pages.pat_login', component: 'login', command: 0, icon: "log-in", showOnLogin: false, showAsGuest: true, hideAsDoc: true, separate: false, onlyInWeb: false, href: "/login/patient", expanded: false, children: [] },
		{ title: 'pages.pat_dashboard', component: 'dashboard', command: 0, icon: "calendar", showOnLogin: true, showAsGuest: false, hideAsDoc: false, separate: false, onlyInWeb: false, href: "/dashboard", expanded: false, children: [] },
		{ title: 'pages.pat_settings', component: 'einstellungen', command: 0, icon: "settings", showOnLogin: true, showAsGuest: false, hideAsDoc: false, separate: true, onlyInWeb: false, href: "/einstellungen", expanded: false, children: [] },
		{ title: 'pages.pat_messages', component: 'nachrichten', command: 0, icon: "chatbubbles", showOnLogin: true, showAsGuest: false, hideAsDoc: true, separate: false, onlyInWeb: false, href: "/nachrichten", expanded: false, children: [] },
		{ title: 'pages.logout', component: 'suche', command: 1, icon: "log-out", showOnLogin: true, showAsGuest: false, hideAsDoc: true, separate: true, onlyInWeb: false, href: "/suche", expanded: false, children: [] },
		{ title: 'pages.patmedlist', component: 'patmedlist', command: 0, icon: "newspaper-outline", showOnLogin: true, showAsGuest: true, hideAsDoc: true, separate: true, onlyInWeb: false, href: "/patmedlist", expanded: false, children: [] },
		//{ title: 'pages.patmedlist', component: 'patmedlistnew', command: 0, icon: "newspaper-outline", showOnLogin: true, showAsGuest: true, hideAsDoc: true, separate: true, onlyInWeb: false, href: "/patmedlistnew", expanded: false, children: [] },

	]

	public static FOOTAGE_PAGES = [
		//	{ title: 'Ärzte und Therapeuten', component: 'aerzte-und-therapeuten', command: 0, icon: null, separate: false, showOnLogin: false, showAsGuest: true, onlyInWeb: false, href: "/aerzte-und-therapeuten", expanded: false, children: [] },
		{ title: 'pages.faq', component: 'faq', command: 0, icon: null, separate: false, onlyInWeb: false, href: "/faq", expanded: false, children: [] },
		{ title: 'pages.pat_contact', component: 'contact', command: 0, icon: null, separate: false, onlyInWeb: false, href: "/contact", expanded: false, children: [] },
		{ title: 'pages.about', component: 'about', command: 0, icon: null, separate: false, onlyInWeb: false, href: "/about", expanded: false, children: [] }
	];

	public static FOOTAGE_PAGES_APP = [
		//	{ title: 'Ärzte und Therapeuten', component: 'aerzte-und-therapeuten', command: 0, icon: null, separate: false, showOnLogin: false, showAsGuest: true, onlyInWeb: false, href: "/aerzte-und-therapeuten", expanded: false, children: [] },
		{ title: 'pages.faq', component: 'faq', command: 0, icon: null, separate: false, onlyInWeb: false, href: "/faq", expanded: false, children: [] },
		{ title: 'pages.pat_contact', component: 'contact', command: 0, icon: null, separate: false, onlyInWeb: false, href: "/contact", expanded: false, children: [] },
		//{ title: 'pages.about', component: 'about', command: 0, icon: null, separate: false, onlyInWeb: false, href: "/about", expanded: false, children: [] }
	];


	public static FOOTAGE_LEGALS = [
		{ title: 'pages.legal', component: 'legals', command: 0, icon: null, separate: false, onlyInWeb: false, href: "/legals", expanded: false, children: [] },
		{ title: 'pages.privacy', component: 'privacy', command: 0, icon: null, separate: false, onlyInWeb: false, href: "/privacy", expanded: false, children: [] },
		{ title: 'pages.agb', component: 'agb', command: 0, icon: null, separate: false, onlyInWeb: false, href: "/agb", expanded: false, children: [] },
		{ title: 'pages.accessibility', component: 'accessibility', command: 0, icon: null, separate: false, onlyInWeb: false, href: "/accessibility", expanded: false, children: [] }
	];

}
